import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export enum HttpMethod {
    Get,
    Post,
    Put,
    Patch,
    Delete
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    public static get baseApiUrl(): string {
        return `${environment.dashApiUrl}/api/`;
    }

    constructor(protected http: HttpClient) {
    }

    private readonly headers = new HttpHeaders().set('Content-Type', 'application/json');

    apiRequest<T>(url: string, httpMethod: HttpMethod, httpBody?: any, correlationId?: string): Observable<T> {
        if (url.length > 2080) {
            const urlWithoutParams = url.split('?');
            throw new URIError(`apiRequest URI (${urlWithoutParams[0]}) is too long. This may indicate an API error. Consult the factory.`);
        }

        let headers = this.headers;
        if (correlationId) { headers = headers.set('X-Correlation-ID', correlationId);}

        return this.http.request<T>(HttpMethod[httpMethod], url, { headers: headers, body: httpBody });
    }

    patchTransform(object: object) {
        return Object.keys(object).map(key => ({
            op: 'replace',
            path: `/${key}`,
            value: object[key],
        }));
    }
}
